import { BadgeProps } from "@chakra-ui/react";
import { CommandStatus } from "../types/command.types";
import Badge from "./Badge";

function OrderStatusBadge({
  halted,
  status,
  width = "fit-content",
  ...props
}: { halted: boolean; status: CommandStatus | "HALTED"; width?: string } & BadgeProps) {
  const generateBadge = (
    textColor: string,
    borderColor: string,
    backgroundColor: string,
    label: string
  ) => {
    return (
      <Badge
        w={width}
        lineHeight="20px"
        fontSize="14px"
        fontWeight="500"
        px="12px"
        py="4px"
        rounded={1000}
        backgroundColor={backgroundColor}
        color={textColor}
        border={"solid 1px"}
        borderColor={borderColor}
        textAlign="center"
        ml={props.ml}
      >
        {label}
      </Badge>
    );
  };
  // 1. Halted special case
  if (halted) {
    return generateBadge("#FFFFFF", "#C2410C", "#F68511", "En pause");
  }
  // 2. Generic case
  const mapping = new Map<string, [string, string, string, string]>([
    [CommandStatus.DRAFT, ["#FFFFFF", "#1E293B", "#334155", "Brouillon"]],
    [
      CommandStatus.WAITING_FOR_RECEPTION,
      ["#334155", "#E2E8F0", "#F8FAFC", "En attente de réception"],
    ],
    [CommandStatus.RECEIVED, ["#000000", "#BCD9FF", "#D9E9FF", "Réceptionnée"]],
    [
      CommandStatus.MODELING,
      ["#000000", "#85E13A", "#A6EF67", "En modélisation"],
    ],
    [
      CommandStatus.PRINTING,
      ["#000000", "#4ADE80", "#4ADE80", "En impression"],
    ],
    [
      CommandStatus.INJECTING,
      ["#FFFFFF", "#16A34A", "#16A34A", "En injection silicone"],
    ],
    [CommandStatus.POLISHING, ["#FFFFFF", "#087443", "#326212", "En finition"]],
    [CommandStatus.QUALITY_CONTROL, ["#087443", "#326212", "#FFFFFF", "Contrôle qualité"]],
    [
      CommandStatus.READY_FOR_DELIVERY,
      ["#FFFFFF", "#2B75FF", "#599FFF", "Prête à livrer"],
    ],
    [CommandStatus.IN_DELIVERY, ["#FFFFFF", "#1444E1", "#1B58F5", "Expédiée"]],
    [CommandStatus.ABORTED, ["#FFFFFF", "#B91C1C", "#DC2626", "Annulée"]],
    [CommandStatus.PENDING, ["#FFFFFF", "#C2410C", "#F68511", "En pause"]],
    [CommandStatus.DELIVERED, ["#FFFFFF", "#142157", "#19338F", "Livrée"]],
  ]);
  const statusMapping = mapping.get(status);
  if (!statusMapping) {
    return <>---</>;
  }
  return generateBadge(...statusMapping);
}

export default OrderStatusBadge;
